var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "" } },
    [
      _c(
        "v-card",
        { staticClass: "rounded-card" },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c("h2", { staticClass: "h2_title mb-1" }, [
                _vm._v("\n        Información de Actividad de Despacho\n      ")
              ]),
              _c("v-divider"),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    "mt-5": "",
                    layout: "",
                    wrap: ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Actividad de Despacho", readonly: "" },
                        model: {
                          value: _vm.data.nombre_add,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_add", $$v)
                          },
                          expression: "data.nombre_add"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Fecha Creación", readonly: "" },
                        model: {
                          value: _vm.data.fecha_creacion,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "fecha_creacion", $$v)
                          },
                          expression: "data.fecha_creacion"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Nombre Alta", readonly: "" },
                        model: {
                          value: _vm.data.nombre_alta,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_alta", $$v)
                          },
                          expression: "data.nombre_alta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Nota de Venta", readonly: "" },
                        model: {
                          value: _vm.data.nombre_ndv,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_ndv", $$v)
                          },
                          expression: "data.nombre_ndv"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Técnico", readonly: "" },
                        model: {
                          value: _vm.data.nombre_tecnico,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_tecnico", $$v)
                          },
                          expression: "data.nombre_tecnico"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Propietario", readonly: "" },
                        model: {
                          value: _vm.data.nombre_propietario,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_propietario", $$v)
                          },
                          expression: "data.nombre_propietario"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Tipo de Instalación", readonly: "" },
                        model: {
                          value: _vm.data.nombre_tipo_instalacion,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_tipo_instalacion", $$v)
                          },
                          expression: "data.nombre_tipo_instalacion"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Tipo de Envio", readonly: "" },
                        model: {
                          value: _vm.data.nombre_tipo_envio,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_tipo_envio", $$v)
                          },
                          expression: "data.nombre_tipo_envio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Area Responsable", readonly: "" },
                        model: {
                          value: _vm.data.area_responsable,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "area_responsable", $$v)
                          },
                          expression: "data.area_responsable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Tipo de Despacho", readonly: "" },
                        model: {
                          value: _vm.data.nombre_tipo_despacho,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nombre_tipo_despacho", $$v)
                          },
                          expression: "data.nombre_tipo_despacho"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Cantidad de Equipos", readonly: "" },
                        model: {
                          value: _vm.data.cantidad_equipos,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "cantidad_equipos", $$v)
                          },
                          expression: "data.cantidad_equipos"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Guía de Despacho", readonly: "" },
                        model: {
                          value: _vm.data.guia_despacho,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "guia_despacho", $$v)
                          },
                          expression: "data.guia_despacho"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Fecha Despacho", readonly: "" },
                        model: {
                          value: _vm.data.fecha_despacho,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "fecha_despacho", $$v)
                          },
                          expression: "data.fecha_despacho"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Fecha Recepción", readonly: "" },
                        model: {
                          value: _vm.data.fecha_recepcion,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "fecha_recepcion", $$v)
                          },
                          expression: "data.fecha_recepcion"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Despachado Por", readonly: "" },
                        model: {
                          value: _vm.data.despachado_por,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "despachado_por", $$v)
                          },
                          expression: "data.despachado_por"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Recepcionado Por", readonly: "" },
                        model: {
                          value: _vm.data.recepcionado_por,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "recepcionado_por", $$v)
                          },
                          expression: "data.recepcionado_por"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Estado", readonly: "" },
                        model: {
                          value: _vm.data.estado,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "estado", $$v)
                          },
                          expression: "data.estado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Razon del Estado", readonly: "" },
                        model: {
                          value: _vm.data.razon_estado,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "razon_estado", $$v)
                          },
                          expression: "data.razon_estado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Cliente", readonly: "" },
                        model: {
                          value: _vm.data.cliente,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "cliente", $$v)
                          },
                          expression: "data.cliente"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Fecha Recepción en Conecta",
                          readonly: ""
                        },
                        model: {
                          value: _vm.data.fecha_recepcion_conecta,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "fecha_recepcion_conecta", $$v)
                          },
                          expression: "data.fecha_recepcion_conecta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Recepcionado Por en Conecta",
                          readonly: ""
                        },
                        model: {
                          value: _vm.data.recepcionado_por_conecta,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "recepcionado_por_conecta", $$v)
                          },
                          expression: "data.recepcionado_por_conecta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Estado en Conecta", readonly: "" },
                        model: {
                          value: _vm.data.estado_conecta,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "estado_conecta", $$v)
                          },
                          expression: "data.estado_conecta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Número de Encomienda", readonly: "" },
                        model: {
                          value: _vm.data.numero_despacho,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "numero_despacho", $$v)
                          },
                          expression: "data.numero_despacho"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Glosa Transmisión", readonly: "" },
                        model: {
                          value: _vm.data.datos_transmision,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "datos_transmision", $$v)
                          },
                          expression: "data.datos_transmision"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-textarea", {
                        attrs: { label: "Observaciones", readonly: "" },
                        model: {
                          value: _vm.data.observaciones,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "observaciones", $$v)
                          },
                          expression: "data.observaciones"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Obs. Dirección Despacho",
                          readonly: ""
                        },
                        model: {
                          value: _vm.data.observaciones_direccion_despacho,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.data,
                              "observaciones_direccion_despacho",
                              $$v
                            )
                          },
                          expression: "data.observaciones_direccion_despacho"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }